<template>
    <v-layout column mb-5>
      
      <v-flex class="position-relative mb-5" style="display: flex; align-items: center; justify-content: center; text-align: center;">

        <v-flex tag="h2" class="mb-0">
          Tell about the job
        </v-flex>

        <v-flex v-if="update" style="position: absolute; right: 15px;">
          <v-span class="status" v-if="jobStatus === 'archived'">Published Job</v-span>
          <v-span class="status red" v-else>Archived Job</v-span>
        </v-flex>
      </v-flex>


        <v-flex>
            <v-layout>
                <v-flex xs12>
                      <span :class="{'app-text-light d-inline-block mb-2': true, 'error--text is-invalid': errors.has('type_work_list')}">
                                    Type of work*</span>
                    <v-select placeholder="Please choose"
                              v-model="job.type_work_list[0]"
                              :items="workTypes"
                              item-value="id"
                              item-text="name"
                              v-validate="'required'"
                              data-vv-name="type_work_list"
                              :menu-props="{offsetY: true}"
                              flat
                              solo>
                        <template slot="selection"
                                  slot-scope="{item, index}">
                            <span class="text--black">{{ item.name | capitalize }}</span>
                        </template>
                    </v-select>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex>
            <span :class="{'d-inline-block mb-2': true, 'error--text is-invalid': errors.has('availability_list')}">
                                    I specifically need care on*</span>
            <app-table-availability-rates v-model="job.availability_list"
                                          v-validate="'required'"
                                          :error-messages="errors.first('availability_list')"
                                          data-vv-name="close_date"></app-table-availability-rates>
        </v-flex>
        <v-flex tag="h2" my-5 text-xs-center>
            Pay per Hour
        </v-flex>
        <v-flex xs12>
          <span :class="{'d-inline-block mb-2': true, 'error--text is-invalid': errors.has('payperhour')}">
                                    Pay per Hour*</span>
          <v-text-field
            prefix="$"
            v-model="job.payperhour"
            v-validate="'required'"
            maxlength="45"
            data-vv-name="payperhour"
            :error-messages="errors.first('payperhour')"
            flat
            solo
            class="app-text-field"></v-text-field>
        </v-flex>
        <!--Job date-->
        <v-flex>
          <v-layout row wrap grid-list-lg mt-3>
              <v-flex xs12 md6>
                  <!-- Start Date Picker -->
                  <v-menu ref="menu"
                          :close-on-content-click="false"
                          v-model="datePicker2"
                          :nudge-top="30"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          attach="#datePicker2"
                          id="datePicker2"
                          min-width="100%">
                      <v-text-field
                          slot="activator"
                          v-model="computedDateStart"
                          v-validate="'required'"
                          :error-messages="errors.first('start_date')"
                          data-vv-name="start_date"
                          label="Job start date*"
                          persistent-hint
                          outline></v-text-field>
                      <v-date-picker 
                          v-model="job.date_start"
                          :min="minStartDate"
                          width="100%"
                          no-title
                          @input="onStartDateSelected"></v-date-picker>
                  </v-menu>
              </v-flex>
              
              <v-flex xs12 md6>
                  <!-- Close Date Picker -->
                  <v-menu ref="menu"
                          :close-on-content-click="false"
                          v-model="datePicker1"
                          :nudge-top="30"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          attach="#datePicker1"
                          id="datePicker1"
                          class="datepickermain"
                          min-width="100%">
                      <v-text-field
                          slot="activator"
                          v-model="computedDateClose"
                          label="Job archive date*"
                          v-validate="'required'"
                          :error-messages="errors.first('close_date')"
                          data-vv-name="close_date"
                          persistent-hint
                          outline></v-text-field>
                      <v-date-picker 
                          v-model="job.date_close"
                          :min="minCloseDate"
                          width="100%"
                          no-title
                          @input="datePicker1 = false"></v-date-picker>
                  </v-menu>
              </v-flex>
          </v-layout>
      </v-flex>


      
<!--        
        <v-flex xs12>
            <div class="d-flex">
                                <span :class="{'app-text-light d-inline-block mb-2': true, 'error--text is-invalid': errors.has('child_count')}">
                                    Children to be cared for at a time*</span>
                <span class="app-text-medium text-xs-right">{{ job.child_count || '1-5+'}}</span>
            </div>
            <v-slider v-model="job.child_count"
                      v-validate="'required|min_value:1'"
                      data-vv-name="child_count"
                      :max="5"
                      class="my-0"></v-slider>
        </v-flex>
-->        
        <v-flex tag="h2" my-5 text-xs-center>
            Any required credentials for the carer?
        </v-flex>

        <!-- Caregiver category starts-->
        <v-flex xs12>
          <span :class="{'app-text-light d-inline-block mb-2 labelclass': true,'error--text is-invalid': errors.first('caregiver_category_list')}">Looking for</span>
              <AppBtnTogglecareg @caregivemain_cat="getcaregiver_listing($event)" v-model="job.caregiver_category_list"  data-vv-name="caregiver_category_list" icon-dir="brand" propvalue="caregiverscategory" :items="caregivers"></AppBtnTogglecareg> 
        </v-flex>  


        <v-flex xs12 mt-3 v-if="childopt">
          <div>
              <span :class="{'app-text-light d-inline-block mb-2 labelclass': true}">
                Housekeeping preferences</span>
          </div>
          <app-btn-toggle-qualifications  @sub_cat_eventhandler="getcaregiver_sublisting($event)" v-model="job.caregiver_category_listing_options"  data-vv-name="caregiver_category_listing_options" icon-dir="brand" propvalue="caregivesubcategory" :items="childopt"></app-btn-toggle-qualifications>                                           
        </v-flex>

        <!-- Caregiver category end-->


        <!--personal qualifications-->
        <v-flex xs12>
            <div>
                                <span :class="{'app-text-light d-inline-block mb-2': true, 'error--text is-invalid': errors.first('personal_questions_list')}">
                                    Select personal qualifications*</span>
            </div>
            <app-btn-toggle-qualifications v-model="job.personal_questions_list"
                                           icon-dir="brand"
                                           v-validate="'required'"
                                           data-vv-name="personal_questions_list"
                                           :items="qualifications"></app-btn-toggle-qualifications>
        </v-flex>
        <!--work preferences-->
        <!--<v-flex xs12>
            <div>
                                <span :class="{'app-text-light d-inline-block mb-2': true, 'error--text is-invalid': errors.first('work_preferences_list')}">
                                    Select work preferences*</span>
            </div>
            <app-btn-toggle-qualifications v-model="job.work_preferences_list"
                                           icon-dir="brand"
                                           v-validate="'required'"
                                           data-vv-name="work_preferences_list"
                                           :items="preferences"></app-btn-toggle-qualifications>
        </v-flex>-->
        <v-flex xs12>
          <v-checkbox label="NannyGranny must have valid Working With Children Check"
                        :ripple="false" disabled input-value="1"></v-checkbox>
        </v-flex>
        <!--Job descriptions-->
        <v-flex tag="h2" my-5 text-xs-center>
            Job description
        </v-flex>
        <v-flex xs12>
            <v-textarea
                    label="A brief statement about the position* (100 characters is recommended)"
                    v-model="job.description"
                    v-validate="'required'"
                    data-vv-name="description"
                    :error-messages="errors.first('description')"
                    maxlength="500"
                    height="128"
                    outline
                    no-resize
                    class="app-textarea"></v-textarea>
        </v-flex>
        <v-flex xs12>
            <v-text-field label="Job title*"
                          v-model="job.name"
                          v-validate="'required'"
                          maxlength="45"
                          data-vv-name="title"
                          :error-messages="errors.first('title')"
                          flat
                          solo
                          class="app-text-field"></v-text-field>
        </v-flex>
        <v-flex>
            <span class="app-text-light d-inline-block mb-2">Job listing background</span>
            <app-card-job-select-bg v-model="job.theme_body"></app-card-job-select-bg>
        </v-flex>
        <!--Actions-->
        <v-flex text-xs-center my-5>
            <v-div class="">

              

            <v-flex v-if="update">

              <v-btn
              v-if="jobStatus === 'archived'"
              @click="archiveJob"
              color="secondary"
              dark
              class="v-btn--default elevation-0">
              Archive
            </v-btn>
            
            <v-btn
            v-if="jobStatus === 'published'"
            @click="publishJob"
              color="primary"
              dark
              class="v-btn--default elevation-0">
              Publish
            </v-btn>

            <v-btn 
              @click="submit('UPDATE', 'UPDATE')"
              color="primary"
              class="v-btn--default elevation-0">
              Update
            </v-btn>
            
          </v-flex>
          

              
            <v-btn v-else
            :loading="loading"
            @click="submit('STORE', 'STORE')"
            color="primary"
            class="v-btn--default elevation-0">
            Post a Job
          </v-btn>

        </v-div>
            <app-btn-view-profile :item="job"
                                  hide-bottom-panel
                                  class="d-link d-block mx-auto mt-3 _btn-preview">Preview</app-btn-view-profile>
        </v-flex>
    </v-layout>
</template>

<script>
  import Job from '@/models/JobClass'
  import { mapGetters } from 'vuex'
  import AppTableAvailabilityRates from '../../../../components/app-table/app-table-availability-rates'
  import AppBtnToggleQualifications from '../../../../components/app-buttons/app-btn-toggle-qualifications'
  import AppCardJobSelectBg from '../../../../components/app-card/app-card-job-select-bg'
  import AppBtnTogglecareg from '../../../../components/app-buttons/app-btn-toggle-caregiver'
  import AppBtnViewProfile from '../../../../components/app-buttons/app-btn-view-profile'

  export default {
    name: 'app-job-form',
    components: {AppBtnViewProfile, AppCardJobSelectBg, AppBtnToggleQualifications, AppTableAvailabilityRates,AppBtnTogglecareg},
    props: {
      value: {
        type: Job,
        default: () => new Job({type_work_list: [], is_visible: 1})
      },
      update: Boolean
    },

    data () {
      return {
        job: this.value,
        maskDate: '####-##-##',
        datePicker1: false,
        datePicker2: false,
        childopt:null,
        minStartDate: new Date().toISOString().substr(0, 10),
        minCloseDate: null,
        dictionary: {
          attributes: {
            type_work_list: 'type of work',
            looking_available: ' ',
            close_date: 'close date',
            start_date: 'start date'
          }
        }
      }
    },

    computed: {
      ...mapGetters('catalogs', [
        'workTypes',
        'childAge',
        'qualifications',
        'preferences',
        'residenceStatuses',
        'availability',
        'caregivers'
      ]),
      ...mapGetters('jobs', [
        'loading'
      ]),
      computedDateStart () {
        return this.formatDate(this.job.date_start)
      },
      computedDateClose () {
        return this.formatDate(this.job.date_close)
      },
      jobStatus() {
        if (!this.job.date_close) return 'published';
        const today = new Date();
        const closeDate = new Date(this.job.date_close);
        return closeDate > today ? 'archived' : 'published';
      }
    },

    mounted () {

      this.$store.dispatch('jobs/JOBS_GET').then(() => {
          this.item = this.$store.getters['jobs/collection'][0]
          if(this.item.id){
           // this.$router.push({name: 'job-listing'})
           this.$root.$router.push({
            path: '/job-listing', 
            query: { jobexists: 'true' }
        })
          }
        })

      this.$validator.localize('en', this.dictionary)
      localStorage.removeItem("subcategory_caregiver");
      var getdefault_subcat=this.job.caregiver_category_listing_options;
      localStorage.setItem("subcategory_caregiver", JSON.stringify(getdefault_subcat));
    },

    methods: {
      getcaregiver_listing: function(getevent_arr) { 
        /*var getslice_val=clickvalue.split("=");
        var if_chdild=getslice_val[2];
        console.log(getslice_val);*/
        var categoryid=getevent_arr[0];
        var if_selected=getevent_arr[1];
        var if_chdild=getevent_arr[2];
        if(if_selected==true){
          this.$store.dispatch('catregiver_subcategory/FETCH_CAREGIVER_SUBCATEGORY',categoryid)
        .then((res) => {
          let get_childs=this.$store.getters['catregiver_subcategory/subcategory'];
          if(get_childs){
            if(get_childs.length>1){
              this.childopt=get_childs;
              //console.log(JSON.parse(localStorage.getItem("subcategory_caregiver")));
              this.job.caregiver_category_listing_options=JSON.parse(localStorage.getItem("subcategory_caregiver"));
              }else{
                this.childopt=null;
              }
          }else{
            this.childopt=null;
          }
         
        })
        }else{
          if(if_chdild==1){
            this.job.caregiver_category_listing_options=[];
          }
          this.childopt=null;
        }
      },
      getcaregiver_sublisting: function(event_arr) { 
        console.log(event_arr);
        var categoryid=event_arr[0];
        var if_selected=event_arr[1];
        if(if_selected==true){
          let selectedelements = JSON.parse(localStorage.getItem("subcategory_caregiver")) 
          console.log(selectedelements.indexOf(parseInt(categoryid)))
          if(selectedelements.indexOf(parseInt(categoryid))== -1)  
          selectedelements.push(parseInt(categoryid));
          localStorage.setItem("subcategory_caregiver", JSON.stringify(selectedelements));
        }else{
          var getselecteditems=JSON.parse(localStorage.getItem("subcategory_caregiver"));
          const index = getselecteditems.indexOf(parseInt(categoryid));
          if (index > -1) { // only splice array when item is found
              getselecteditems.splice(index, 1); // 2nd parameter means remove one item only
          }
          localStorage.setItem("subcategory_caregiver",  JSON.stringify(getselecteditems));
          console.log(localStorage.getItem("subcategory_caregiver"))
        }
        console.log(JSON.parse(localStorage.getItem("subcategory_caregiver")));
      },

      onStartDateSelected(date) {
        this.datePicker2 = false;
        this.job.date_start = date;
        this.minCloseDate = this.addOneDay(date); // Set the minimum close date as the next day
        this.job.date_close = null; // Reset close date when a new start date is selected
      },
      // Add one day to the selected start date
      addOneDay(date) {
        const selectedDate = new Date(date);
        selectedDate.setDate(selectedDate.getDate() + 1);
        return selectedDate.toISOString().substr(0, 10);
      },
      archiveJob() {
        const today = new Date();
        today.setDate(today.getDate() - 1);
        this.job.date_close = today.toISOString().substr(0, 10);

        this.submit('UPDATE', 'ARCHIVE');
      },
      publishJob() {
        const today = new Date();
        today.setDate(today.getDate() + 1);
        this.job.date_close = today.toISOString().substr(0, 10);

        this.submit('UPDATE', 'PUBLISH');
      },
      submit (action, job_type) {
        this.$validator.validateAll().then(result => {
          this.job.is_wwcverify=1;
          if (result) {
            this.$store.dispatch(`jobs/JOBS_${action}`, this.job)
                .then(() => {
                  if (job_type === 'UPDATE') {
                    localStorage.setItem("subcategory_caregiver", JSON.stringify(this.job.caregiver_category_listing_options)); 
                    this.showSnackBar('The Job has updated successfully', 'success')
                  }else if(job_type === 'ARCHIVE'){
                    localStorage.setItem("subcategory_caregiver", JSON.stringify(this.job.caregiver_category_listing_options)); 
                    this.showSnackBar('The Job has archive successfully', 'success')
                  }
                  else if(job_type === 'PUBLISH'){
                    localStorage.setItem("subcategory_caregiver", JSON.stringify(this.job.caregiver_category_listing_options)); 
                    this.showSnackBar('The Job has published successfully', 'success')
                  }
                  else if(job_type === 'STORE') {
                    this.showSnackBar('Your Job Post is live', 'success')
                    this.$router.push({name: 'job-listing'})
                  }
                })
          } else {
            this.goToError()
          }
        })
      },
      goToError () {
        try {
          this.$vuetify.goTo(`[data-vv-name="${this.errors.items[0].field || 'type_work_list'}"]`, {offset: -150})
        } catch (e) {
          console.warn(e)
        }
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      }
    }
  }
</script>

<style lang="stylus" scoped>
    ._btn-preview
        font-size 1rem !important
        text-decoration underline
    @media (min-width: 1500px) and (max-width: 1640px)
      .datepickermain .v-menu__content
        min-width 90% !important
    @media (min-width: 1400px) and (max-width: 1499px)
      .datepickermain .v-menu__content
        min-width 85% !important
    @media (min-width: 1325px) and (max-width: 1399px)
      .datepickermain .v-menu__content
        min-width 80% !important
    @media (min-width: 1240px) and (max-width: 1324px)
      .datepickermain .v-menu__content
        min-width 75% !important
    @media (min-width: 1160px) and (max-width: 1239px)
      .datepickermain .v-menu__content
        min-width 70% !important
    @media (min-width: 1080px) and (max-width: 1159px)
      .datepickermain .v-menu__content
        min-width 65% !important
    @media (min-width: 1000px) and (max-width: 1079px)
      .datepickermain .v-menu__content
        min-width 60% !important
    @media (min-width: 960px) and (max-width: 999px)
      .datepickermain .v-menu__content
        min-width 55% !important
    @media (max-width: 850px)
      .datepickermain .v-menu__content
        min-width 90% !important

      
    .status {
      font-weight: bold;
      color: #08979D;
      font-size: 18px;
    }
    .red {
      color: red;
    }

</style>



// WEBPACK FOOTER //
// src/views/app/jobs/components/job-form.vue